import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { FortuneWheelBonus } from "../../../entities/wheelGame_v2";
import { getWheelBonus, patchWheelBonus, postWheelBonus } from "./thunks";

interface FortuneWheelBonusState {
  loading: boolean,
  saveLoading: boolean,
  bonus?: FortuneWheelBonus,
}

const initialState: FortuneWheelBonusState = {
  loading: false,
  saveLoading: false,
}

const saveFortuneWheel = (
  builder: ActionReducerMapBuilder<FortuneWheelBonusState>,
  action: any
) => {
  builder.addCase(action.pending, (state: FortuneWheelBonusState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: FortuneWheelBonusState, action: PayloadAction<FortuneWheelBonus>) => {
    state.saveLoading = false;
    state.bonus = action.payload;
  });
  builder.addCase(action.rejected, (state: FortuneWheelBonusState) => {
    state.saveLoading = false;
  });
};

export const fortuneWheelBonusStore = createSlice({
  name: "fortuneWheelBonus",
  initialState: initialState,
  reducers: {
    clearBonus: (state) => {
      state.bonus = undefined;
    }
  },
  extraReducers: (builder) => {
    // getWheelBonus
    builder.addCase(getWheelBonus.pending, state => {
      state.loading = true;
    })
    builder.addCase(getWheelBonus.fulfilled, (state, action) => {
      state.bonus = action.payload;

      state.loading = false;
    })
    const saveActions = [postWheelBonus,
      patchWheelBonus];
      
    saveActions.forEach((action) => { saveFortuneWheel(builder, action) })
  },
})

export const { clearBonus } = fortuneWheelBonusStore.actions

export default fortuneWheelBonusStore.reducer;